<template>
  <div class="design-rirekisho-002-preview-doc">
    <!--デザイン履歴書1枚目-->
    <div
      class="d-doc-paper preview rirekisho"
      :id="idPrefix + 'preview-page-01'"
      :style="docPaperStyle"
    >
      <div class="d2-rirekisho-box1" style="width: 100%">
        <div
          class="rirekisho-header"
          style="display: flex; justify-content: end"
        >
          <div
            class="date"
            @click="goCardTo('create-date')"
            :class="highLightClass('create-date')"
          >
            <span v-html="formatedCreateDate"></span> 現在
          </div>
        </div>
      </div>

      <!--画像部分-->
      <div style="position: relative; overflow: visible">
        <div
          class="main-image"
          :data-highlight="highlightMessage"
          @click="goCardTo('main-image')"
          :class="highLightClass('main-image')"
        >
          <!--<img alt="メイン画像">-->
          <img
            v-if="formatData.mainImageSrc"
            :src="formatData.mainImageSrc"
            alt="メイン画像"
            style="
              width: 100%;
              height: 200px;
              overflow: hidden;
              object-fit: cover;
            "
          />
          <p
            v-else
            style="
              width: 100%;
              height: 200px;
              overflow: hidden;
              object-fit: cover;
              border: 1px dotted #000;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            メイン画像
          </p>
        </div>
        <div
          class="id-photo"
          :data-highlight="highlightMessage"
          @click="goCardTo('id-photo')"
          :class="highLightClass('id-photo')"
        >
          <!-- メイン画像あり: 170px, left: 25px -->
          <template v-if="formatData && formatData.mainImageSrc">
            <img
              v-if="basicData.idPhotoSrc"
              :src="basicData.idPhotoSrc"
              alt="証明写真"
              style="
                position: absolute;
                border-radius: 50%;
                top: 100px;
                left: 25px;
                width: 170px;
                height: 170px;
                object-fit: cover;
                border: none;
              "
            />
            <p
              v-else
              style="
                position: absolute;
                border-radius: 50%;
                top: 100px;
                left: 25px;
                width: 170px;
                height: 170px;
                object-fit: cover;
                border: none;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #fff;
              "
            >
              証明写真
            </p>
          </template>
          <!-- メイン画像なし: 150px, left: 35px -->
          <template v-else>
            <img
              v-if="basicData.idPhotoSrc"
              :src="basicData.idPhotoSrc"
              alt="証明写真"
              style="
                position: absolute;
                border-radius: 50%;
                top: 100px;
                left: 35px;
                width: 150px;
                height: 150px;
                object-fit: cover;
                border: 1px solid #404040;
              "
            />
            <p
              v-else
              style="
                position: absolute;
                border-radius: 50%;
                top: 100px;
                left: 35px;
                width: 150px;
                height: 150px;
                object-fit: cover;
                border: 1px solid #404040;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #fff;
              "
            >
              証明写真
            </p>
          </template>
        </div>
      </div>

      <!--コンテンツ部分-->
      <div
        class="flex d002-content"
        style="
          display: flex;
          font-size: 14px;
          margin-top: 80px;
          justify-content: space-between;
          min-height: 820px;
          overflow: hidden;
        "
      >
        <div class="d002-sidebar" :style="sidebarStyle">
          <!--名前、職種、誕生年-->
          <div style="text-align: center; margin-bottom: 30px">
            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('design-profile')"
              :class="highLightClass('profile')"
              class="d-name"
            >
              <div
                :style="formatData.selFontStyle"
                style="font-size: 20px; font-weight: bold"
              >
                {{ basicData.lastName }}&#32;{{ basicData.firstName }}
              </div>
            </div>

            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('design-profile')"
              :class="highLightClass('profile')"
              class="d-birthday"
            >
              <div>
                （<span>{{ basicData.birthYear }}</span
                >年）
              </div>
            </div>

            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('job-category')"
              class="d-occupation"
              style="
                border: 1px solid #404040;
                border-radius: 50px;
                padding: 1px 10px;
                display: inline-block;
                font-size: 12px;
                margin-top: 5px;
              "
            >
              <div :style="formatData.selFontStyle">
                {{ formatData.job_category }}
              </div>
            </div>
          </div>

          <!--連絡先-->
          <div style="margin-bottom: 30px">
            <h3 style="font-size: 16px; text-align: center; margin-bottom: 5px">
              CONTACT
            </h3>
            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('contacts')"
              :class="highLightClass('contacts')"
              class="d-tel"
              style="margin-bottom: 5px"
            >
              <!--<div class="label">電話番号</div>-->
              <div class="input" :style="formatData.selFontStyle">
                {{ tel }}
              </div>
            </div>
            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('contacts')"
              :class="highLightClass('contacts')"
              class="d-mail"
              style="margin-bottom: 5px"
            >
              <!--<div class="label">メールアドレス</div>-->
              <div class="input" :style="formatData.selFontStyle">
                {{ basicData.email }}
              </div>
            </div>
            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('address')"
              :class="highLightClass('address')"
              class="d-address"
            >
              <!--<div class="label">住所</div>-->
              <div class="input" :style="formatData.selFontStyle">
                &#12306;{{ formLib.separatedPostNumber(basicData.postNumber)
                }}<br />
                {{ basicData.address1 }}{{ basicData.address2 }}
              </div>
            </div>
          </div>

          <!--スキル-->
          <div style="margin-bottom: 30px">
            <h3 style="font-size: 16px; text-align: center; margin-bottom: 5px">
              SKILL
            </h3>
            <ul
              :data-highlight="highlightMessage"
              @click="goCardTo('skills')"
              style="list-style: none; padding-left: 0; margin: 0"
            >
              <li v-for="(item, index) in formatData.skills" :key="index">
                <ul
                  class="flex flex-center m-bottom skill-flex"
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 5px;
                    list-style: none;
                    padding-left: 0;
                  "
                >
                  <li class="skill-kinds" :style="formatData.selFontStyle">
                    {{ item.description }}
                  </li>
                  <li>
                    <span
                      v-for="n in item.skill_level"
                      :key="'skill-full-' + n"
                      class="skill-full"
                      style="color: #0f9934"
                      >★</span
                    >
                    <span
                      v-for="n in 5 - item.skill_level"
                      :key="'skill-empty-' + n"
                      class="skill-full"
                      style="color: #0f9934"
                      >☆</span
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <!--趣味-->
          <div
            :data-highlight="highlightMessage"
            @click="goCardTo('hobby')"
            :class="highLightClass('hobby')"
          >
            <h3 style="font-size: 16px; text-align: center; margin-bottom: 5px">
              HOBBY
            </h3>
            <ul
              class="flex"
              style="
                display: flex;
                font-size: 14px;
                list-style: none;
                padding-left: 0;
                margin: 0;
                flex-wrap: wrap;
                justify-content: center;
                gap: 10px;
              "
            >
              <li
                v-for="(val, idx) in formatData.hobbies"
                :key="idx"
                class="hobby-item"
                style="
                  line-height: 1.2;
                  width: calc(100% / 3 - 10px);
                  text-align: center;
                "
              >
                <img
                  :src="hobbyOptions[val.id]?.image"
                  style="line-height: 1.2; height: 40px; margin-bottom: 2px"
                /><br />
                <span style="font-size: 9px; white-space: nowrap">{{
                  val.name
                }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div style="width: calc(100% - 240px)">
          <!--学歴-->
          <div
            @click="goCardTo('edu-history')"
            :class="highLightClass(['edu-history'])"
            style="margin-bottom: 20px"
          >
            <h3 style="font-size: 16px; margin-bottom: 5px">EDUCATION</h3>
            <ul style="list-style: none; padding-left: 0; margin: 0">
              <li
                v-for="(item, index) in formatData.educationalHistories"
                :key="index"
                style="display: flex"
              >
                <p :style="formatData.selFontStyle" style="width: 60px">
                  {{ item.year }}.{{ item.month }}
                </p>
                <p
                  :style="formatData.selFontStyle"
                  style="width: calc(100% - 60px)"
                >
                  {{ item.description }}
                </p>
              </li>
            </ul>
          </div>

          <!--資格-->
          <div
            @click="goCardTo('license-history')"
            :class="highLightClass(['license-history'])"
            style="margin-bottom: 20px"
          >
            <h3 style="font-size: 16px; margin-bottom: 5px">LICENSE</h3>
            <ul style="list-style: none; padding-left: 0; margin: 0">
              <li
                v-for="(item, index) in formatData.licenseHistories"
                :key="index"
                style="display: flex"
              >
                <p :style="formatData.selFontStyle" style="width: 60px">
                  {{ item.year }}.{{ item.month }}
                </p>
                <p
                  :style="formatData.selFontStyle"
                  style="width: calc(100% - 60px)"
                >
                  {{ item.description }}
                </p>
              </li>
            </ul>
          </div>

          <!--PR-->
          <div @click="goCardTo('mypr')" :class="highLightClass(['mypr'])">
            <h3 style="font-size: 16px; margin-bottom: 5px">PR</h3>
            <div class="input">
              <pre
                ref="mypr"
                :class="classObject.mypr"
                :style="formatData.selFontStyle"
                style="
                  white-space: pre-wrap;
                  line-height: 1.8;
                  margin: 0;
                  font-family:
                    'Noto Sans JP', 'Noto Sans JP Regular',
                    'Noto Sans Japanese', MyFontFamily, 'Segoe UI Emoji',
                    'Segoe UI Symbol', 'Apple Color Emoji', 'Noto Color Emoji',
                    'Noto Emoji', sans-serif;
                "
                >{{ formatData.mypr }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DesignRirekisho002PreviewDocPage2
      :format-data="formatData"
      :id-prefix="idPrefix"
      :doc-paper-page2-style="docPaperPage2Style"
      :go-card-to="goCardTo"
      :high-light-class="highLightClass"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'
import hobbyOptions from '@/utils/format-edit/designRirekishoHobbyOptions.json'
import {
  designRirekisho002DocPaperStyle,
  designRirekisho002DocPaperPage2Style,
  designRirekisho002SidebarStyle
} from '@/utils/format-edit/designRirekisho002PreviewStyles'
import DesignRirekisho002PreviewDocPage2 from '@/components/format-edit/design-rirekisho/DesignRirekisho002PreviewDocPage2.vue'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const {
  mypr,
  checkValid,
  formLib,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  tel,
  formatedCreateDate,
  errorMessages,
  optionItems
} = useRirekishoPreview(props, {
  maxEduJobRows: 22,
  maxLicenseRows: 6,
  textareaMaxHeights: { mypr: 180 },
  overflowFields: ['mypr', 'addressFurigana'],
  revalidateOnFormatDataChange: true
})

const docPaperStyle = computed(() =>
  designRirekisho002DocPaperStyle(!!props.isSample)
)
const docPaperPage2Style = computed(() =>
  designRirekisho002DocPaperPage2Style(!!props.isSample)
)
const sidebarStyle = computed(() =>
  designRirekisho002SidebarStyle(!!props.isSample)
)

defineExpose({ checkValid, errorMessages, optionItems, mypr })
</script>
